(function () {
  'use strict';

  var activeModal = null;
  var activeTrigger = null;
  var focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function isVisible(element) {
    return Boolean(element && element.getClientRects().length);
  }

  function getFocusableElements(modal) {
    var focusable = Array.from(modal.querySelectorAll(focusableSelector)).filter(isVisible);

    // Boost renders its mobile search controls as a portal outside the search
    // dialog. Include only that visible control panel in the dialog focus loop.
    if (modal.querySelector('input[name="boost-q"]')) {
      document.querySelectorAll('.boost-pfs-search-suggestion-mobile-top-panel').forEach(function (panel) {
        if (!isVisible(panel)) return;
        panel.querySelectorAll(focusableSelector).forEach(function (element) {
          if (isVisible(element) && focusable.indexOf(element) === -1) focusable.push(element);
        });
      });
    }

    return focusable;
  }

  function openModal(modal, trigger) {
    activeModal = modal;
    activeTrigger = trigger;
    modal.setAttribute('aria-hidden', 'false');

    window.requestAnimationFrame(function () {
      var initialFocus = modal.querySelector('[data-a11y-modal-initial-focus]');
      var focusable = getFocusableElements(modal);
      (initialFocus || focusable[0] || modal).focus({ preventScroll: true });
    });
  }

  function closeModal(modal) {
    var hiddenClass = modal.getAttribute('data-a11y-modal-hidden-class');
    if (hiddenClass) {
      modal.classList.add(hiddenClass);
    } else {
      modal.style.display = 'none';
    }

    modal.setAttribute('aria-hidden', 'true');

    var trigger = activeTrigger;
    activeModal = null;
    activeTrigger = null;
    if (trigger && document.contains(trigger)) trigger.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (event) {
    var openButton = event.target.closest('[data-a11y-modal-open]');
    if (openButton) {
      var modal = document.getElementById(openButton.getAttribute('data-a11y-modal-open'));
      if (modal) openModal(modal, openButton);
      return;
    }

    var closeButton = event.target.closest('[data-a11y-modal-close]');
    if (closeButton) {
      var containingModal = closeButton.closest('[data-a11y-modal]');
      if (containingModal) closeModal(containingModal);
      return;
    }

    if (activeModal && event.target === activeModal) closeModal(activeModal);
  }, true);

  document.addEventListener('keydown', function (event) {
    var closeButton = event.target.closest && event.target.closest('[data-a11y-modal-close]');
    if (closeButton && (event.key === 'Enter' || event.key === ' ')) {
      var containingModal = closeButton.closest('[data-a11y-modal]');
      if (containingModal) {
        event.preventDefault();
        event.stopImmediatePropagation();
        closeModal(containingModal);
      }
      return;
    }

    if (!activeModal) return;
    if (event.defaultPrevented) return;

    if (event.key === 'Escape') {
      var expandedCombobox = event.target.closest &&
        event.target.closest('[role="combobox"][aria-expanded="true"]');
      if (expandedCombobox && activeModal.contains(expandedCombobox)) return;

      event.preventDefault();
      closeModal(activeModal);
      return;
    }

    if (event.key !== 'Tab') return;

    var focusable = getFocusableElements(activeModal);
    if (!focusable.length) {
      event.preventDefault();
      activeModal.focus();
      return;
    }

    var currentIndex = focusable.indexOf(document.activeElement);
    var nextIndex = event.shiftKey ? currentIndex - 1 : currentIndex + 1;

    if (currentIndex === -1 || nextIndex >= focusable.length) nextIndex = 0;
    if (nextIndex < 0) nextIndex = focusable.length - 1;

    event.preventDefault();
    focusable[nextIndex].focus();
  }, true);
})();
